import { Typography } from "@mui/material";

// ----------------------------------------------------------------------

export const VumiTitle = () => {
	return (
		<div
			style={{
				position: "absolute",
				bottom: 0
			}}
		>
			<Typography color='text.secondary' sx={{ px: 5, mb: 4 }} variant='body2'>
				{"© 2025 Vumi Portfolio S.L."}
			</Typography>
		</div>
	);
};

export default VumiTitle;
